import { render, staticRenderFns } from "./QuoteBlock.vue?vue&type=template&id=00f7ea86&"
import script from "./QuoteBlock.js?vue&type=script&lang=js&"
export * from "./QuoteBlock.js?vue&type=script&lang=js&"
import style0 from "./QuoteBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./QuoteBlock.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fblocks%2FQuoteBlock%2FQuoteBlock.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports